import styled, { css } from 'styled-components'

// base size used by the Customize drawer's "Default" color-mode swatch, matched there against
// the 14px "Custom" color-picker circle right next to it. This one is a fixed circle regardless of
// the Display tab's colorStyle choice - it's a mode-selector control, not "how this channel's color
// is shown in the list", so it never switches to the bar shape.
export const ColorDot = styled.span<{ color?: string }>`
    flex-shrink: 0;
    display: inline-block;
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background-color: ${({ color }) => color ?? 'var(--gray-400)'};
`

// the Available/Selected/Removed row lists' own color indicator - circle or vertical bar, the two
// alternative "color style" choices from the Display tab (see api.ts's ColorStyle). Same footprint/
// position either way, just a shape swap - the row layout itself is unchanged. 12px circle is a 25%
// reduction from the original 16px.
export const RowColorMark = styled.span<{ color?: string; shape: 'circle' | 'bar' }>`
    flex-shrink: 0;
    display: inline-block;
    background-color: ${({ color }) => color ?? 'var(--gray-400)'};

    ${({ shape }) =>
        shape === 'bar'
            ? css`
                  height: 32px;
                  width: 4px;
                  border-radius: 2px;
              `
            : css`
                  height: 12px;
                  width: 12px;
                  border-radius: 50%;
              `}
`

export const RowInfo = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
`

export const RowTitle = styled.span`
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: var(--gray-1000);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

// wraps RowMeta (and, when present, the leading dynamic-channel icon) so the icon sits inline at
// the start of the second line instead of floating up next to the title on the first
export const RowMetaLine = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
`

export const RowMeta = styled.span`
    flex: 1;
    min-width: 0;
    font-size: 11px;
    line-height: 16px;
    color: var(--gray-600);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`
